<template>
  <div class="col-md-12 col-sm-12 col-xs-12">
    <div class="x_panel">
      <div class="x_title">
        <h2>Products</h2>
        <div class="clearfix"></div>
      </div>
      <div class="x_content">
        <div class="table-responsive">
          <table class="table table-striped">
            <thead>
              <tr class="headings">
                <th class="column-title">Description & Size</th>
                <th class="column-title">Product Code</th>
                <th class="column-title">Bar Code</th>
                <th class="column-title">Quantity</th>
                <th class="column-title">Amount (USD)</th>
              </tr>
            </thead>
            <tfoot v-if="item.products.length > 0">
              <tr>
                <td></td>
                <td></td>
                <td></td>
                <td><strong>Total Amount:</strong></td>
                <td><strong>{{ item.amount | currency }}</strong></td>
              </tr>
            </tfoot>
            <tbody v-if="item.products.length > 0">
              <tr
                class="even"
                v-for="product in item.products"
                :key="product.productCode">
                <td class=" ">{{ product.description }}</td>
                <td class=" ">{{ product.productCode }}</td>
                <td class=" ">{{ product.barCode }}</td>
                <td class=" ">{{ product.quantity }}</td>
                <td class="">{{ product.price * product.quantity | currency }}
                ( {{ product.price | currency }} each)</td>
              </tr>
            </tbody>
            <tbody v-else>
              <tr>
                <td
                  colspan="5"
                  class="text-center">
                  <h3>No products found!</h3>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    item: {
      type: Object,
      default() {
        return {};
      },
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/purchase-orders/purchase-order/partials/PoProducts.vue